// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTheme } from '@mui/material';

import Tile, { TileProps } from '@components/Timeline/Tile/Tile';
import TileIconLyft from '@components/Timeline/Tile/TileIconLyft';

// TYPES ---------------------------------------------------------------- //

export interface LyftRideProps
  extends Omit<
    TileProps,
    'color' | 'extraWidthBeforeLabel' | 'extraWidthBetweenLabel' | 'extraWidthAfterLabel' | 'secondaryIcon' | 'variant'
  > {}

// COMPONENT ---------------------------------------------------------------- //

const LyftRide = ({ ...props }: LyftRideProps) => {
  const theme = useTheme();

  return (
    <Tile
      color={theme.palette.lyft.main}
      extraWidthBeforeLabel={`WAIT`}
      extraWidthBetweenLabel={`???`}
      extraWidthAfterLabel={`RIDE`}
      secondaryIcon={<TileIconLyft />}
      variant={`outlined`}
      {...props}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default LyftRide;
